<acf>
  return component('hub', [
  ]);
</acf>

<php>
  return function($content) {
    $pieces = [];

    $query = new WP_Query('post_type=piece');

    while ( $query->have_posts() )
    {
      $query->the_post();

      $pieces[] = [
        'id' => get_the_ID(),
        'size' => get_field('size'),
        'type' => get_field('type'),
        'image' => get_the_post_thumbnail_url(null, 'full'),
        'video' => get_field('video'),
        'title' => get_the_title(),
        'author' => get_field('author'),
        'occupation' => get_field('occupation'),
        'description' => wpautop(get_field('description')),
        'url' => get_field('url'),
        'visit' => get_field('visit'),
        'share' => get_permalink()
      ];

    }

    $content['pieces'] = $pieces;

    wp_reset_postdata();

    return $content;
  };
</php>

<script>
  import HubItem from '../partials/HubItem.vue'

  import Isotope from 'isotope-layout'
  import imagesLoaded from 'imagesloaded'

  export default {
    props: ['content'],

    data () {
      let params = new URLSearchParams(location.search.slice(1));

      return {
        id: params.get('id')
      }
    },

    components: {
      HubItem
    },

    mounted () {
      imagesLoaded(this.$refs.grid, () => {
        this.$grid = new Isotope(this.$refs.grid, {
          itemSelector: '.grid-item',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        })
      })
    },

    methods: {
      sizeClass (i) {
        if (this.content.pieces[i].size !== 'auto')
          return this.content.pieces[i].size

        let order = [
          'thumb left',
          'large',
          'thumb right',

          'large',
          'thumb left',
          'thumb right',

          'thumb left',
          'thumb left',

          'thumb right',
          'thudmb right'
        ]

        return order[i % order.length]
      },

      layout () {
        this.$grid.arrange()
      },

    }
  }
</script>

<template>
  <div class="section">
    <div class="container">
      <div class="grid" ref="grid">
        <div class="grid-sizer"></div>
        <hub-item
          class="grid-item"
          :class="sizeClass(i)"
          v-for="(piece, i) in content.pieces"
          :key="piece.title"
          :piece="piece"
          :reveal="id"
          @layout="layout"
        ></hub-item>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    background: $pippin;
  }

  .filter {
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-bottom: 1rem;

    @include tablet { display: flex; }
  }

  .label {
    font-family: Separat;
    font-size: 1.5rem;
  }

  .filter a {
    display: block;
    margin-bottom: 1rem;
  }

  .filter a:before {
    display: inline-block;
    content: "";
    width: 40px;
    height: 40px;
    background: black;
    vertical-align: middle;
    margin-right: 25px;
  }

  @each $type, $colour in $types {
    .filter a.#{$type}:before {
      background: $colour;
    }
  }

  .grid:after {
    content: '';
    display: block;
    clear: both;
  }

  .grid-sizer, .grid-item {
    width: 100%;
  }

  .grid-item {
    float: left;
  }

  .filtered {
    filter: grayscale(100%);
  }

  @include desktop {
    .grid-sizer, .grid-item {
      width: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// components/Hub.vue